/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Article Module State
==========================================================================================*/

export default {
  articles: [
  ],
  periode: 3  ,//mensuel ,trimes ,annuel
  selectedyear : new Date().getFullYear(),
}
